import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { useStore } from 'react-redux'
import { setIn } from '#/utils/object'
import { viewUrlFromPlace } from '#/utils/properties'
import { state2MapUrl } from '#/utils/url'

export const useGotoPlace = () => {
  const router = useRouter()
  const store = useStore<TopHap.StoreState>()

  return useCallback((place: TopHap.Place | null) => {
    if (!place) return

    if (place.place_type[0] === 'address') {
      router.push(viewUrlFromPlace(place))
    } else {
      let newStore = store.getState()
      newStore = setIn(newStore, 'preferences.places', { items: [place], reason: 'init' })
      newStore = setIn(newStore, 'preferences.map.viewport', {
        bounds: place.bbox,
        updatedBy: 'USER'
      }, true)
      router.push(state2MapUrl(newStore))
    }
  }, [router, store])
}
